import styled, { css } from 'styled-components';

export const Badge = styled.span<{ $compact: boolean }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;

  ${({ theme: { colors }, $compact }) => css`
    padding: ${$compact ? '0' : '0 4px 0 9px'};
    width: ${$compact ? '30px' : 'auto'};
    height: ${$compact ? '30px' : '26px'};
    justify-content: center;
    color: ${colors.primary};
    background: color-mix(in srgb, ${colors.primary} 14%, transparent);
    box-shadow: inset 0 0 0 1px color-mix(in srgb, ${colors.primary} 35%, transparent);
  `}
`;

export const Status = styled.span<{ $hidden: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  background: ${({ theme }) => theme.colors.surfaceContainerHighest};

  ${({ $hidden }) =>
    $hidden &&
    css`
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      overflow: hidden;
      clip-path: inset(50%);
    `}
`;
